import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axiosInstance, { setToken, clearToken } from "../../features/shared/api/axiosInstance";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get("/users/profile");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
    const onShow = (e) => { if (e.persisted) window.location.reload(); };
    window.addEventListener("pageshow", onShow);
    return () => window.removeEventListener("pageshow", onShow);
  }, [refreshUser]);

  const login = useCallback(async (credentials) => {
    const { data } = await axiosInstance.post("/auth/login", credentials);
    setToken(data.token);
    const { data: profile } = await axiosInstance.get("/users/profile");
    setUser(profile);
    return profile;
  }, []);

  const logout = useCallback(async () => {
    try { await axiosInstance.post("/auth/logout"); } catch { /* ignore */ }
    clearToken();
    setUser(null);
  }, []);

  const value = { user, loading, login, logout, refreshUser };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
